import { subWeeks } from 'date-fns';
import { BookingFailureStatus } from './booking-failure-status.enum';

export class GetBookingFailuresRequestFilters {
  createdOnFrom = subWeeks(new Date(), 1);
  createdOnTo = new Date();
  bookingRefNumber: string;
  bookingRetryStatuses = [BookingFailureStatus.Running, BookingFailureStatus.Scheduled];
}
